export const storage = {
  set (key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.error('Storage set error:', error)
    }
  },

  get (key, defaultValue = null) {
    try {
      const value = localStorage.getItem(key)
      return value ? JSON.parse(value) : defaultValue
    } catch (error) {
      console.error('Storage get error:', error)
      return defaultValue
    }
  },

  remove (key) {
    localStorage.removeItem(key)
  },

  clear () {
    localStorage.clear()
  }
}

// 专门用于token的存储
export const tokenStorage = {
  setToken (token) {
    try {
      // 确保token是字符串格式，去除可能的引号
      const cleanToken = typeof token === 'string' ? token.replace(/^["']|["']$/g, '') : String(token)
      console.log('tokenStorage.setToken - 输入token:', token)
      console.log('tokenStorage.setToken - 清理后token:', cleanToken)
      console.log('tokenStorage.setToken - token长度:', cleanToken.length)
      
      localStorage.setItem('Authorization', cleanToken)
      
      // 验证存储是否成功
      const stored = localStorage.getItem('Authorization')
      console.log('tokenStorage.setToken - 验证存储:', stored)
      console.log('tokenStorage.setToken - 存储长度:', stored ? stored.length : 0)
    } catch (error) {
      console.error('tokenStorage.setToken 错误:', error)
    }
  },

  getToken () {
    try {
      // 直接获取token字符串，确保去除引号
      const token = localStorage.getItem('Authorization') || ''
      const cleanToken = token.replace(/^["']|["']$/g, '')
      console.log('tokenStorage.getToken - 原始token:', token)
      console.log('tokenStorage.getToken - 清理后token:', cleanToken)
      console.log('tokenStorage.getToken - token长度:', cleanToken.length)
      return cleanToken
    } catch (error) {
      console.error('tokenStorage.getToken 错误:', error)
      return ''
    }
  },

  removeToken () {
    try {
      localStorage.removeItem('Authorization')
      console.log('tokenStorage.removeToken - token已清除')
    } catch (error) {
      console.error('tokenStorage.removeToken 错误:', error)
    }
  },

  hasToken () {
    try {
      const token = localStorage.getItem('Authorization')
      const hasToken = !!(token && token.replace(/^["']|["']$/g, ''))
      console.log('tokenStorage.hasToken - token存在:', hasToken)
      return hasToken
    } catch (error) {
      console.error('tokenStorage.hasToken 错误:', error)
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js